<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-button v-if="data.item.nuevoM2 !== true"
      @click="showModal(data.item)"
      variant="outline-warning"
      >Rechazar</b-button
    >

  </div>
</template>

<script>
export default {
  name: "BandejaRechazarPTIComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    motivoRechazo: null,
    loading: false,
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },

  methods: {
    showModal(idSolicitudDiagnostico) {
      this.$emit("_funcionExtra4", idSolicitudDiagnostico);
    },
  },
};
</script>
